import { render, staticRenderFns } from "./AdminCategories.vue?vue&type=template&id=2b5decfe"
import script from "./AdminCategories.vue?vue&type=script&lang=js"
export * from "./AdminCategories.vue?vue&type=script&lang=js"
import style0 from "./AdminCategories.vue?vue&type=style&index=0&id=2b5decfe&prod&lang=scss"
import style1 from "./AdminCategories.vue?vue&type=style&index=1&id=2b5decfe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports